import { render } from "./MainView.vue?vue&type=template&id=e705b812&scoped=true&ts=true"
import script from "./MainView.vue?vue&type=script&lang=ts"
export * from "./MainView.vue?vue&type=script&lang=ts"

import "./MainView.vue?vue&type=style&index=0&id=e705b812&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e705b812"]])

export default __exports__